import { captureClientEvent } from '@charitystack/shared/analytics';

export function safeCapture(posthog, eventName, properties = {}) {
  captureClientEvent(posthog, eventName, properties, {
    appName: 'dashboard',
  });
}
